export enum ConditionStatusFilter {
  All = 'All',
  Created = 'Created',
  Modified = 'Modified',
  Approved = 'Approved',
  Archived = 'Archived',
}
